(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renolivo-contact"]) return;
  try {
    
  function prefillRenolivoEnquiry() {
    const product = new URLSearchParams(window.location.search).get('product');
    if (!product) return;
    const panel = document.getElementById('RenolivoEnquiry');
    if (!panel) return;
    const field = panel.querySelector('input[name="contact[Order or product reference]"], input[name="contact[Products and quantities]"]');
    if (field && !field.value) field.value = product.slice(0, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillRenolivoEnquiry, {once:true});
  } else {
    prefillRenolivoEnquiry();
  }
  document.addEventListener('shopify:section:load', prefillRenolivoEnquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renolivo-footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.rnl-cookie-preferences');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => window.location.assign(link.href));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renolivo-header"]) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.matches('#RnlLanguage')) event.target.form.requestSubmit();});

  } catch(e) { console.error(e); }
})();
})();
